import type { InboxItem } from './types'

// The row's url is absolute (the same link the email carries); the router
// wants the path
export const itemPath = ({ url }: InboxItem): string =>
  url.replace(/^https?:\/\/[^/]+/, '')

// A row's own loader while its project opens: the project id would dim every
// row of that project
export const itemLoader = ({ id }: InboxItem): string => `inbox_${id}`
